function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "calendar");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "calendar",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Calender-Type-2",
  transform: "translate(3.000000, 6.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  stroke: "currentColor",
  strokeWidth: 4,
  x: 0,
  y: 4.10526316,
  width: 44,
  height: 33.8947368,
  rx: 2
}), React.createElement("line", {
  x1: 2.17391304,
  y1: 16.8421053,
  x2: 41.826087,
  y2: 16.8421053,
  id: "Path-8",
  stroke: "currentColor",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("line", {
  x1: 5.2356978,
  y1: 8.42105323,
  x2: 21.0251715,
  y2: 8.42105323,
  id: "Path-8",
  stroke: "currentColor",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "translate(13.130435, 8.421053) rotate(-90.000000) translate(-13.130435, -8.421053) "
}), React.createElement("line", {
  x1: 24.0183058,
  y1: 8.42105255,
  x2: 39.8077795,
  y2: 8.42105255,
  id: "Path-8-Copy",
  stroke: "currentColor",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "translate(31.913043, 8.421053) rotate(-90.000000) translate(-31.913043, -8.421053) "
}), React.createElement("g", {
  id: "Group-3",
  transform: "translate(11.565217, 21.052632)",
  fill: "currentColor",
  fillRule: "nonzero"
}, React.createElement("ellipse", {
  id: "Oval-Copy",
  cx: 2.08695652,
  cy: 2.10526316,
  rx: 2.08695652,
  ry: 2.10526316
}), React.createElement("ellipse", {
  id: "Oval-Copy-6",
  cx: 2.08695652,
  cy: 10.5263158,
  rx: 2.08695652,
  ry: 2.10526316
}), React.createElement("ellipse", {
  id: "Oval-Copy-2",
  cx: 10.4347826,
  cy: 2.10526316,
  rx: 2.08695652,
  ry: 2.10526316
}), React.createElement("ellipse", {
  id: "Oval-Copy-7",
  cx: 10.4347826,
  cy: 10.5263158,
  rx: 2.08695652,
  ry: 2.10526316
}), React.createElement("ellipse", {
  id: "Oval-Copy-3",
  cx: 18.7826087,
  cy: 2.10526316,
  rx: 2.08695652,
  ry: 2.10526316
}), React.createElement("ellipse", {
  id: "Oval-Copy-8",
  cx: 18.7826087,
  cy: 10.5263158,
  rx: 2.08695652,
  ry: 2.10526316
}))));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.d3e6a550.svg";
export { ForwardRef as ReactComponent };